/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * RakeBack Wizard API
 * OpenAPI spec version: 1.0.0
 */
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query'

import type {
  AccountingRedemptionHistoryListParams,
  AccountingTransactionHistoryListParams,
  PaginatedRedemptionHistoryList,
  PaginatedTransactionHistoryList,
  RedemptionHistory,
} from '../models'

import accountingRecentRedemptionsListMutator from '../../client'
import accountingRedemptionHistoryListMutator from '../../client'
import accountingTransactionHistoryListMutator from '../../client'

/**
 * API view to list the last 10 redemption transactions for a logged-in user.
This provides a quick look at recent points expenditures.
 */
export const accountingRecentRedemptionsList = (signal?: AbortSignal) => {
  return accountingRecentRedemptionsListMutator<RedemptionHistory[]>({
    url: `/api/v1/accounting/recent-redemptions/`,
    method: 'GET',
    signal,
  })
}

export const getAccountingRecentRedemptionsListQueryKey = () => {
  return [`/api/v1/accounting/recent-redemptions/`] as const
}

export const getAccountingRecentRedemptionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof accountingRecentRedemptionsList>>, TError, TData>
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountingRecentRedemptionsListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountingRecentRedemptionsList>>> = ({
    signal,
  }) => accountingRecentRedemptionsList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountingRecentRedemptionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountingRecentRedemptionsList>>
>
export type AccountingRecentRedemptionsListQueryError = unknown

export function useAccountingRecentRedemptionsList<
  TData = Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof accountingRecentRedemptionsList>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
        TError,
        Awaited<ReturnType<typeof accountingRecentRedemptionsList>>
      >,
      'initialData'
    >
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingRecentRedemptionsList<
  TData = Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof accountingRecentRedemptionsList>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
        TError,
        Awaited<ReturnType<typeof accountingRecentRedemptionsList>>
      >,
      'initialData'
    >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingRecentRedemptionsList<
  TData = Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof accountingRecentRedemptionsList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountingRecentRedemptionsList<
  TData = Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof accountingRecentRedemptionsList>>, TError, TData>
  >
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountingRecentRedemptionsListQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getAccountingRecentRedemptionsListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
      TError,
      TData
    >
  >
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountingRecentRedemptionsListQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountingRecentRedemptionsList>>> = ({
    signal,
  }) => accountingRecentRedemptionsList(signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountingRecentRedemptionsListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountingRecentRedemptionsList>>
>
export type AccountingRecentRedemptionsListSuspenseQueryError = unknown

export function useAccountingRecentRedemptionsListSuspense<
  TData = Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingRecentRedemptionsListSuspense<
  TData = Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingRecentRedemptionsListSuspense<
  TData = Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountingRecentRedemptionsListSuspense<
  TData = Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof accountingRecentRedemptionsList>>,
      TError,
      TData
    >
  >
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountingRecentRedemptionsListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * API view to provide a complete list of all redemption transactions
for the authenticated user. Filters only actual redemptions (subscriptions,
crypto exchanges, site transfers) and excludes earning adjustments and
manual adjustments.
 */
export const accountingRedemptionHistoryList = (
  params?: AccountingRedemptionHistoryListParams,
  signal?: AbortSignal,
) => {
  return accountingRedemptionHistoryListMutator<PaginatedRedemptionHistoryList>({
    url: `/api/v1/accounting/redemption-history/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getAccountingRedemptionHistoryListQueryKey = (
  params?: AccountingRedemptionHistoryListParams,
) => {
  return [`/api/v1/accounting/redemption-history/`, ...(params ? [params] : [])] as const
}

export const getAccountingRedemptionHistoryListQueryOptions = <
  TData = Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingRedemptionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountingRedemptionHistoryList>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountingRedemptionHistoryListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountingRedemptionHistoryList>>> = ({
    signal,
  }) => accountingRedemptionHistoryList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountingRedemptionHistoryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountingRedemptionHistoryList>>
>
export type AccountingRedemptionHistoryListQueryError = unknown

export function useAccountingRedemptionHistoryList<
  TData = Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
  TError = unknown,
>(
  params: undefined | AccountingRedemptionHistoryListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountingRedemptionHistoryList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
          TError,
          Awaited<ReturnType<typeof accountingRedemptionHistoryList>>
        >,
        'initialData'
      >
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingRedemptionHistoryList<
  TData = Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingRedemptionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountingRedemptionHistoryList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
          TError,
          Awaited<ReturnType<typeof accountingRedemptionHistoryList>>
        >,
        'initialData'
      >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingRedemptionHistoryList<
  TData = Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingRedemptionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountingRedemptionHistoryList>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountingRedemptionHistoryList<
  TData = Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingRedemptionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountingRedemptionHistoryList>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountingRedemptionHistoryListQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getAccountingRedemptionHistoryListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingRedemptionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
        TError,
        TData
      >
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountingRedemptionHistoryListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountingRedemptionHistoryList>>> = ({
    signal,
  }) => accountingRedemptionHistoryList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountingRedemptionHistoryListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountingRedemptionHistoryList>>
>
export type AccountingRedemptionHistoryListSuspenseQueryError = unknown

export function useAccountingRedemptionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
  TError = unknown,
>(
  params: undefined | AccountingRedemptionHistoryListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingRedemptionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingRedemptionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingRedemptionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingRedemptionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountingRedemptionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingRedemptionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountingRedemptionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountingRedemptionHistoryListSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * API view to provide a list of all financial transactions
for the authenticated user.
 */
export const accountingTransactionHistoryList = (
  params?: AccountingTransactionHistoryListParams,
  signal?: AbortSignal,
) => {
  return accountingTransactionHistoryListMutator<PaginatedTransactionHistoryList>({
    url: `/api/v1/accounting/transaction-history/`,
    method: 'GET',
    params,
    signal,
  })
}

export const getAccountingTransactionHistoryListQueryKey = (
  params?: AccountingTransactionHistoryListParams,
) => {
  return [`/api/v1/accounting/transaction-history/`, ...(params ? [params] : [])] as const
}

export const getAccountingTransactionHistoryListQueryOptions = <
  TData = Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountingTransactionHistoryList>>, TError, TData>
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountingTransactionHistoryListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountingTransactionHistoryList>>> = ({
    signal,
  }) => accountingTransactionHistoryList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountingTransactionHistoryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountingTransactionHistoryList>>
>
export type AccountingTransactionHistoryListQueryError = unknown

export function useAccountingTransactionHistoryList<
  TData = Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
  TError = unknown,
>(
  params: undefined | AccountingTransactionHistoryListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountingTransactionHistoryList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
          TError,
          Awaited<ReturnType<typeof accountingTransactionHistoryList>>
        >,
        'initialData'
      >
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingTransactionHistoryList<
  TData = Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountingTransactionHistoryList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
          TError,
          Awaited<ReturnType<typeof accountingTransactionHistoryList>>
        >,
        'initialData'
      >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingTransactionHistoryList<
  TData = Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountingTransactionHistoryList>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountingTransactionHistoryList<
  TData = Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accountingTransactionHistoryList>>, TError, TData>
    >
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountingTransactionHistoryListQueryOptions(params, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const getAccountingTransactionHistoryListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
        TError,
        TData
      >
    >
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAccountingTransactionHistoryListQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountingTransactionHistoryList>>> = ({
    signal,
  }) => accountingTransactionHistoryList(params, signal)

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountingTransactionHistoryListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountingTransactionHistoryList>>
>
export type AccountingTransactionHistoryListSuspenseQueryError = unknown

export function useAccountingTransactionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
  TError = unknown,
>(
  params: undefined | AccountingTransactionHistoryListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingTransactionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountingTransactionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAccountingTransactionHistoryListSuspense<
  TData = Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
  TError = unknown,
>(
  params?: AccountingTransactionHistoryListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof accountingTransactionHistoryList>>,
        TError,
        TData
      >
    >
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAccountingTransactionHistoryListSuspenseQueryOptions(params, options)

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
